const config = require('@aurora/theme-saas/tailwind.config.js');

module.exports = {
  content: ['./src/**/*.{html,js,,ts,vue}', './node_modules/@aurora/vue-*/lib/*.js'],
  theme: {
    extend: {},
    screens: {
      sm: '640px',
      xl: '1000px',
    },
  },
  corePlugins: {
    preflight: false,
    filter: false,
  },
  presets: [config],
  safelist: [],
};
